import { actions } from '../constants/examSession';
import * as actionTypes from '../../models/action/examSession';
import * as actionTypesAddExamSession from '../../models/action/examSessionAdd';
import { Log } from 'ng2-logger';
import { IFilter, IFilterAddStudent, IFilterExamQuestions, IFilterExamStudents, IPublishDatas, IQuestions, IStudents } from '../../models/components/add-exam-sessions';
import { IPagedQueryS } from '../../models/components/paginate';

const _logger = Log.create('Exam Add Page');

export function ExamSessionListGetAction(
    activityId: string,
    courseId: string,
    classId: string,
    spinnerId: string,
    spinnerType: 'get' | 'set',
    selectedExamSessionId?: string
): actionTypes.IExamSessionListGetAction {
    return {
        activityId,
        courseId,
        classId,
        spinnerId,
        spinnerType,
        selectedExamSessionId,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_LIST
    };
}

export function ExamSessionListSetAction(
    model: actionTypes.IExamSessionListSetActionModel,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IExamSessionListSetAction {
    return {
        model,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_LIST
    };
}

export function ExamSessionSelectedGetAction(
    examSessionId: string,
    courseId: string,
    classId: string,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IExamSessionSelectedGetAction {
    return {
        examSessionId,
        courseId,
        classId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_SELECTED
    };
}

export function ExamSessionSelectedSetAction(
    selectedSession: actionTypes.ISelectedExamSession,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IExamSessionSelectedSetAction {
    return {
        selectedSession,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_SELECTED
    };
}

export function ExamSessionAddAction(
    session: actionTypes.IExamSessionData,
    spinnerId: string,
    spinnerType: 'get' | 'set',
    callback: (values: any) => void
): actionTypes.IExamSessionAddAction {
    return {
        session,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_ADD
    };
}

export function ExamSessionGetUpdate(
    examSessionId: string,
    courseId: string,
    classId: string,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IExamSessionGetUpdate {
    return {
        examSessionId,
        courseId,
        classId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_UPDATE
    };
}

export function ExamSessionSetUpdate(
    sessionData: actionTypes.IExamSessionData,
    spinnerId: string,
    spinnerType: 'get' | 'set'
): actionTypes.IExamSessionSetUpdate {
    return {
        sessionData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_UPDATE
    };
}

export function ExamSessionSetUpdateDefault(
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IExamSessionSetUpdateDefault {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_UPDATE_DEFAULT
    };
}

export function ExamSessionSetListDefault(
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IExamSessionSetListDefault {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_LIST_DEFAULT
    };
}

export function ExamSessionAddQuestionList(filters: IFilter, paging: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: () => void, ): actionTypesAddExamSession.IExamSessionAddQuestionList {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_ADD_QUESTION_LIST,
        callback
    };
}

export function ExamSessionAddQuestionListDefault(
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IExamSessionSetListDefault {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_ADD_QUESTION_LIST_DEFAULT
    };
}

export function SetExamSessionAddQuestionList(results: IQuestions[], filters: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.ISetExamSessionAddQuestionList {
    return {
        results,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_ADD_QUESTION_LIST
    };
}

export function ExamSessionAddQuestion(
    filters: IFilter, 
    isAll: boolean, 
    examSessionId: string, 
    examId: string, 
    questionIds: string[], 
    callback: () => void, 
    disAllowedQuestionIds?: string[],
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionAddQuestion {
    return {
        filters,
        isAll,
        examSessionId,
        examId,
        questionIds,
        callback,
        disAllowedQuestionIds,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_ADD_QUESTION
    };
}

export function ExamSessionDeleteQuestion(
    isAll: boolean, 
    examSessionId: string, 
    examId: string, 
    questionIds: string[], 
    callback: () => void, 
    disAllowedQuestionIds?: string[],
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionDeleteQuestion {
    return {
        isAll,
        examSessionId,
        examId,
        questionIds,
        callback,
        disAllowedQuestionIds,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_DELETE_QUESTION
    };
}

export function ExamSessionQuestionList(filters: IFilterExamQuestions, paging: IPagedQueryS, examId: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionQuestionList {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_QUESTION_LIST
    };
}

export function SetExamSessionQuestionList(results: IQuestions[], filters: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.ISetExamSessionQuestionList {
    return {
        results,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_QUESTION_LIST
    };
}

export function ExamSessionAddStudentList(filters: IFilterAddStudent, paging: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionAddStudentList {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_ADD_STUDENT_LIST
    };
}

export function ExamSessionAddStudentListDefault(
    spinnerId?: string,
    spinnerType?: 'get' | 'set'
): actionTypes.IExamSessionSetListDefault {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_ADD_STUDENT_LIST_DEFAULT
    };
}

export function SetExamSessionAddStudentList(results: IStudents[], filters: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.ISetExamSessionAddStudentList {
    return {
        results,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_ADD_STUDENT_LIST
    };
}

export function ExamSessionAddStudent(
    filters: IFilterAddStudent, 
    isAll: boolean, 
    examSessionId: string, 
    examId: string, 
    studentIds: string[], 
    callback: () => void, 
    disAllowedStudentIds?: string[],
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionAddStudent {
    return {
        filters,
        isAll,
        examSessionId,
        examId,
        studentIds,
        callback,
        disAllowedStudentIds,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_ADD_STUDENT
    };
}

export function ExamSessionStudentList(filters: IFilterExamStudents, paging: IPagedQueryS, examId: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionStudentList {
    return {
        filters,
        paging,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_STUDENT_LIST
    };
}

export function SetExamSessionStudentList(results: IStudents[], filters: IPagedQueryS, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.ISetExamSessionStudentList {
    return {
        results,
        filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_STUDENT_LIST
    };
}

export function ExamSessionDeleteStudent(
    isAll: boolean, 
    examSessionId: string, 
    examId: string, 
    studentIds: string[], 
    searchedText: string,
    callback: () => void, 
    disAllowedStudentIds?: string[],
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionDeleteStudent {
    return {
        isAll,
        examSessionId,
        examId,
        studentIds,
        searchedText,
        callback,
        disAllowedStudentIds,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_DELETE_STUDENT
    };
}

export function ExamSessionPublishDatas(examId: string, examSessionId: string, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionPublishDatas {
    return {
        examId,
        examSessionId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_PUBLISH_DATAS
    };
}

export function SetExamSessionPublishDatas(publishDatas: IPublishDatas, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.ISetExamSessionPublishDatas {
    return {
        publishDatas,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_EXAM_SESSION_PUBLISH_DATAS
    };
}

export function ExamSessionPublish(
    examSessionId: string, 
    examId: string,
    examSessionBeginDate: Date,
    examSessionEndDate: Date, 
    callback: () => void, 
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionPublish {
    return {
        examSessionId,
        examId,
        examSessionBeginDate,
        examSessionEndDate,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_PUBLISH
    };
}

export function ExamSessionUnpublish(
    examSessionId: string, 
    examId: string, 
    examSessionBeginDate: Date,
    examSessionEndDate: Date, 
    callback: () => void, 
    spinnerId?: string, 
    spinnerType?: 'get' | 'set'): actionTypesAddExamSession.IExamSessionPublish {
    return {
        examSessionId,
        examId,
        examSessionBeginDate,
        examSessionEndDate,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_UNPUBLISH
    };
    
}


export function ExamSessionGetStudent(listType: number, studentList: string[], callback: () => void, spinnerId?: string, spinnerType?: 'get' | 'set') {
    return {
        listType,
        studentList,
        callback,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_STUDENT_CHECK_LIST
    };
}

export function SetExamSessionGetStudent(results: string[], spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypesAddExamSession.ISetExamSessionMultiStudentList {
    return {
        results,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_EXAM_SESSION_STUDENT_CHECK_LIST_DATAS
    };
}
